import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import AdminForm from "./admin-form";
import { adminDoPostAdmin } from "services/admin/admin";
import { showError } from "lib/notification";

interface AddAdminModalProps {
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const AddAdminModal: FunctionComponent<AddAdminModalProps> = ({
  onUpdate,
  onClose,
}) => {
  const onSubmit = async (values: any) => {
    try {
      await adminDoPostAdmin(values);

      // update and close
      onUpdate();
      onClose();
    } catch (err) {
      showError("Ylläpitäjän lisääminen epäonnistui.");
    }
  };

  return (
    <Modal title="Uusi ylläpitäjä">
      <AdminForm admin={undefined} onSubmit={onSubmit} onClose={onClose} />
    </Modal>
  );
};

export default AddAdminModal;
